import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Button, Tab, Loader } from 'semantic-ui-react'

import AppUtils from '../../utils/AppUtils'
import AppConstants from '../../utils/AppConstants'
import ColumnsProvider from '../../utils/ColumnsProvider'
import Confirm from '../../components/elements/Confirm'
import Page from '../../components/elements/Page'
import Header from '../../components/elements/Header'
import Table from '../../components/elements/Table'
import Properties from '../../components/elements/Properties'
import UpdateControlPopup from '../popups/controls/UpdateControlPopup'
import AddControlledProductPopup from '../popups/controlledProducts/AddControlledProductPopup'
import EditControlledProductPopup from '../popups/controlledProducts/EditControlledProductPopup'
import CreateControlTaskPopup from '../popups/controlTasks/CreateControlTaskPopup'
import UpdateControlTaskPopup from '../popups/controlTasks/UpdateControlTaskPopup'
import CreateControlGroupPopup from '../popups/controlGroups/CreateControlGroupPopup'
import UpdateControlGroupPopup from '../popups/controlGroups/UpdateControlGroupPopup'
import ExecuteControlGroupPopup from '../popups/controlGroups/ExecuteControlGroupPopup'
import Grant from '../elements/Grant'

import GetAction from '../../actions/controls/GetFullAction'
import DeleteProductAction from '../../actions/controlledProducts/DeleteAction'
import DeleteTaskAction from '../../actions/controlTasks/DeleteAction'
import DeleteGroupAction from '../../actions/controlGroups/DeleteAction'
import PrintGroupAction from '../../actions/print/PrintControlGroupAction'
import PrintAllAction from '../../actions/print/PrintControlAction'

const TABS = {
  PRODUCTS: 0,
  TASKS: 1,
  GROUPS: 2
}

class ControlViewPage extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      // Active tab
      activeTab: TABS.PRODUCTS,
      // Is editing control infos
      isUpdateControl: false,
      // Is adding a product to the control
      isAddProduct: false,
      // ID of product being edited
      editProductId: null,
      // ID of product being removed
      deleteProductId: null,
      // Is creating a task
      isCreateTask: false,
      // ID of task being edited
      updateTaskId: null,
      // ID of task being removed
      deleteTaskId: null,
      // Is creating a group
      isCreateGroup: false,
      // ID of group being edited
      updateGroupId: null,
      // ID of group being removed
      deleteGroupId: null,
      // ID of group being executed
      executeGroupId: null,
      // ID of group being printed
      printGroupId: null,
      // is printing all groups ?
      isPrintingAll: null
    }

    // Bind events
    this.onChangeActiveTab = this.onChangeActiveTab.bind(this)
    this.onClickControlUpdate = this.onClickControlUpdate.bind(this)
    this.onCloseControlUpdate = this.onCloseControlUpdate.bind(this)
    this.onClickAddProduct = this.onClickAddProduct.bind(this)
    this.onCloseAddProduct = this.onCloseAddProduct.bind(this)
    this.onClickUpdateProduct = this.onClickUpdateProduct.bind(this)
    this.onCloseUpdateProduct = this.onCloseUpdateProduct.bind(this)
    this.onClickRemoveProduct = this.onClickRemoveProduct.bind(this)
    this.onConfirmRemoveProduct = this.onConfirmRemoveProduct.bind(this)
    this.onClickCreateTask = this.onClickCreateTask.bind(this)
    this.onCloseCreateTask = this.onCloseCreateTask.bind(this)
    this.onClickUpdateTask = this.onClickUpdateTask.bind(this)
    this.onCloseUpdateTask = this.onCloseUpdateTask.bind(this)
    this.onClickDeleteTask = this.onClickDeleteTask.bind(this)
    this.onConfirmDeleteTask = this.onConfirmDeleteTask.bind(this)
    this.onClickCreateGroup = this.onClickCreateGroup.bind(this)
    this.onCloseCreateGroup = this.onCloseCreateGroup.bind(this)
    this.onClickUpdateGroup = this.onClickUpdateGroup.bind(this)
    this.onCloseUpdateGroup = this.onCloseUpdateGroup.bind(this)
    this.onClickDeleteGroup = this.onClickDeleteGroup.bind(this)
    this.onConfirmDeleteGroup = this.onConfirmDeleteGroup.bind(this)
    this.onClickExecuteGroup = this.onClickExecuteGroup.bind(this)
    this.onCloseExecuteGroup = this.onCloseExecuteGroup.bind(this)
    this.onClickPrintGroup = this.onClickPrintGroup.bind(this)
    this.onConfirmPrintGroup = this.onConfirmPrintGroup.bind(this)
    this.onClickPrintAll = this.onClickPrintAll.bind(this)
    this.onConfirmPrintAll = this.onConfirmPrintAll.bind(this)
  }

  fetch() {
    this.props.fetch(this.props.controlId)
  }

  getLocationsAlreadyUsed(exceptLocationId=null) {
    if (!this.props.data || !_.isArray(this.props.data.groups)) {
      return [];
    }
    return (
      _.flatten(
        _.map(
          _.filter(
            this.props.data.groups,
            (group) => (group.id !== exceptLocationId)
          ),
          (group) => (group.locations)
        )
      )
    )
  }

  componentDidMount() {
    this.fetch()
  }

  componentDidUpdate(prevProps, prevState) {
    // After a product has been removed, refresh
    if (
      prevProps.deleteProductIsFetching
      &&
      !this.props.deleteProductIsFetching
    ) {
      this.setState({
        deleteProductId: null
      })
      AppUtils.setStatus(
        this.props.deleteProductError
          ? AppConstants.STATUS.TYPE.FAILURE
          : AppConstants.STATUS.TYPE.SUCCESS,
        this.props.deleteProductError
          ? AppUtils.errorToText(this.props.deleteProductError)
          : 'Matériel retiré.'
      )
      if (!this.props.deleteProductError) {
        this.fetch()
      }
    }

    // After a task has been deleted, refresh
    if (
      prevProps.deleteTaskIsFetching
      &&
      !this.props.deleteTaskIsFetching
    ) {
      this.setState({
        deleteTaskId: null
      })
      AppUtils.setStatus(
        this.props.deleteTaskError
          ? AppConstants.STATUS.TYPE.FAILURE
          : AppConstants.STATUS.TYPE.SUCCESS,
        this.props.deleteTaskError
          ? AppUtils.errorToText(this.props.deleteTaskError)
          : 'Tâche supprimée.'
      )
      if (!this.props.deleteTaskError) {
        this.fetch()
      }
    }

    // After a group has been deleted, refresh
    if (
      prevProps.deleteGroupIsFetching
      &&
      !this.props.deleteGroupIsFetching
    ) {
      this.setState({
        deleteGroupId: null
      })
      AppUtils.setStatus(
        this.props.deleteGroupError
          ? AppConstants.STATUS.TYPE.FAILURE
          : AppConstants.STATUS.TYPE.SUCCESS,
        this.props.deleteGroupError
          ? AppUtils.errorToText(this.props.deleteGroupError)
          : 'Groupe supprimé.'
      )
      if (!this.props.deleteGroupError) {
        this.fetch()
      }
    }

    // After printing group, refresh
    if (
      prevProps.printGroupIsFetching
      &&
      !this.props.printGroupIsFetching
    ) {
      this.setState({
        printGroupId: null
      })
      AppUtils.setStatus(
        this.props.printGroupError
          ? AppConstants.STATUS.TYPE.FAILURE
          : AppConstants.STATUS.TYPE.SUCCESS,
        this.props.printGroupError
          ? AppUtils.errorToText(this.props.printGroupError)
          : 'Groupe de contrôle imprimé.'
      )
    }

    // After printing all, refresh
    if (
      prevProps.printAllIsFetching
      &&
      !this.props.printAllIsFetching
    ) {
      this.setState({
        isPrintingAll: false
      })
      AppUtils.setStatus(
        this.props.printAllError
          ? AppConstants.STATUS.TYPE.FAILURE
          : AppConstants.STATUS.TYPE.SUCCESS,
        this.props.printAllError
          ? AppUtils.errorToText(this.props.printAllError)
          : 'Tous les groupes de contrôle imprimés.'
      )
    }
  }

  onChangeActiveTab(e, { activeIndex }) {
    this.setState({
      activeTab: activeIndex
    });
  }

  onClickControlUpdate() {
    this.setState({
      isUpdateControl: true
    })
  }

  onCloseControlUpdate(isDirty) {
    this.setState({
      isUpdateControl: false
    })
    if (isDirty) {
      this.fetch()
    }
  }

  onClickAddProduct() {
    this.setState({
      isAddProduct: true
    })
  }

  onCloseAddProduct(isDirty) {
    this.setState({
      isAddProduct: false
    })
    if (isDirty) {
      this.fetch()
    }
  }

  onClickUpdateProduct(editProductId) {
    return () => {
      this.setState({
        editProductId
      })
    }
  }

  onCloseUpdateProduct(isDirty) {
    this.setState({
      editProductId: null
    })
    if (isDirty) {
      this.fetch()
    }
  }

  onClickRemoveProduct(deleteProductId) {
    return () => {
      this.setState({
        deleteProductId
      })
    }
  }

  onConfirmRemoveProduct(proceed) {
    if (proceed) {
      this.props.deleteProduct(this.props.controlId, this.state.deleteProductId)
    }
    else {
      this.setState({
        deleteProductId: null
      })
    }
  }

  onClickCreateTask() {
    this.setState({
      isCreateTask: true
    })
  }

  onCloseCreateTask(isDirty) {
    this.setState({
      isCreateTask: false
    })
    if (isDirty) {
      this.fetch()
    }
  }

  onClickUpdateTask(updateTaskId) {
    return () => {
      this.setState({
        updateTaskId
      })
    }
  }

  onCloseUpdateTask(isDirty) {
    this.setState({
      updateTaskId: null
    })
    if (isDirty) {
      this.fetch()
    }
  }

  onClickDeleteTask(deleteTaskId) {
    return () => {
      this.setState({
        deleteTaskId
      })
    }
  }

  onConfirmDeleteTask(proceed) {
    if (proceed) {
      this.props.deleteTask(this.state.deleteTaskId)
    }
    else {
      this.setState({
        deleteTaskId: null
      })
    }
  }

  onClickCreateGroup() {
    this.setState({
      isCreateGroup: true
    })
  }

  onCloseCreateGroup(isDirty) {
    this.setState({
      isCreateGroup: false
    })
    if (isDirty) {
      this.fetch()
    }
  }

  onClickUpdateGroup(updateGroupId) {
    return () => {
      this.setState({
        updateGroupId
      })
    }
  }

  onCloseUpdateGroup(isDirty) {
    this.setState({
      updateGroupId: null
    })
    if (isDirty) {
      this.fetch()
    }
  }

  onClickDeleteGroup(deleteGroupId) {
    return () => {
      this.setState({
        deleteGroupId
      })
    }
  }

  onConfirmDeleteGroup(proceed) {
    if (proceed) {
      this.props.deleteGroup(this.state.deleteGroupId)
    }
    else {
      this.setState({
        deleteGroupId: null
      })
    }
  }

  onClickExecuteGroup(executeGroupId) {
    return () => {
      this.setState({
        executeGroupId
      })
    }
  }

  onCloseExecuteGroup(isDirty) {
    this.setState({
      executeGroupId: null
    })
    if (isDirty) {
      this.fetch()
    }
  }

  onClickPrintGroup(printGroupId) {
    return () => {
      this.setState({
        printGroupId
      })
    }
  }

  onConfirmPrintGroup(proceed) {
    if (proceed) {
      this.props.printGroup(this.state.printGroupId)
    }
    else {
      this.setState({
        printGroupId: null
      })
    }
  }

  onClickPrintAll() {
    this.setState({
      isPrintingAll: true
    })
  }

  onConfirmPrintAll(proceed) {
    if (proceed) {
      this.props.printAll(this.props.controlId)
    }
    else {
      this.setState({
        isPrintingAll: false
      })
    }
  }

  render() {
    return (
      <React.Fragment>
        <Page direction={Page.DIRECTION.COL}>
          {
            this.props.isFetching || !this.props.data
              ? <Page.Element
                  flex='1 1 100%'
                >
                  <Loader
                    active={true}
                    content='Chargement...'
                    size='huge'
                  />
                </Page.Element>
              : <React.Fragment>
                  <Page.Element
                    flex='0 0 auto'
                    withBorders={true}
                  >
                    <Header
                      title='Description du contrôle'
                      right={
                        <Grant role={Grant.ROLE.MANAGE}>
                          <Button
                            compact={true}
                            icon='pencil'
                            color='orange'
                            onClick={this.onClickControlUpdate}
                          />
                        </Grant>
                      }
                      alignTop={true}
                    />
                    <Properties
                      content={[
                        {
                          key: 'Nom',
                          value: this.props.data.name
                        },
                        {
                          key: 'Récurrence',
                          value: this.props.data.recurrence.periodic
                            ? `Tous les ${this.props.data.recurrence.value} mois`
                            : this.props.data.recurrence.value
                        },
                        {
                          key: 'Remarque',
                          value: this.props.data.remark || '-'
                        }
                      ]}
                    />
                  </Page.Element>
                  <Tab
                    className='element'
                    style={{
                      flex: '1 1 auto',
                      display: 'flex',
                      flexDirection: 'column'
                    }}
                    menu={{
                      attached: true,
                      tabular: true,
                      style: {
                        flex: '0 0 auto'
                      }
                    }}
                    activeIndex={this.state.activeTab}
                    onTabChange={this.onChangeActiveTab}
                    panes={[
                      {
                        menuItem: 'Matériel à contrôler',
                        render: () => (
                          <Tab.Pane
                            style={{
                              flex: '1 1 auto',
                              display: 'flex',
                              flexDirection: 'column'
                            }}
                          >
                            <Header
                              style={{
                                flex: '0 0 auto'
                              }}
                              title=''
                              right={
                                <Grant role={Grant.ROLE.MANAGE}>
                                  <Button
                                    compact={true}
                                    icon='plus'
                                    content='Ajouter'
                                    color='green'
                                    onClick={this.onClickAddProduct}
                                  />
                                </Grant>
                              }
                            />
                            <Table
                              columns={[
                                // Matériel
                                ColumnsProvider.controlProductName,
                                // Opération
                                ColumnsProvider.controlProductOperation,
                                // Contact d'entretien
                                ColumnsProvider.controlContact,
                                // Actions
                                ColumnsProvider.controlProductActions(this.onClickUpdateProduct, this.onClickRemoveProduct)
                              ]}
                              data={this.props.data.products}
                              error={null}
                              isLoading={false}
                              emptyMessage="Il n'y a pas encore de matériel à contrôler."
                            />
                          </Tab.Pane>
                        )
                      },
                      {
                        menuItem: 'Tâches générales',
                        render: () => (
                          <Tab.Pane
                            style={{
                              flex: '1 1 auto',
                              display: 'flex',
                              flexDirection: 'column'
                            }}
                          >
                            <Header
                              style={{
                                flex: '0 0 auto'
                              }}
                              title=''
                              right={
                                <Grant role={Grant.ROLE.MANAGE}>
                                  <Button
                                    compact={true}
                                    icon='plus'
                                    content='Créer'
                                    color='green'
                                    onClick={this.onClickCreateTask}
                                  />
                                </Grant>
                              }
                            />
                            <Table
                              columns={[
                                // Tâche
                                ColumnsProvider.controlTaskDescription,
                                // Contact d'entretien
                                ColumnsProvider.controlContact,
                                // Actions
                                ColumnsProvider.actionsUpdateDelete(this.onClickUpdateTask, this.onClickDeleteTask, Grant.ROLE.MANAGE, Grant.ROLE.MANAGE)
                              ]}
                              data={this.props.data.tasks}
                              error={null}
                              isLoading={false}
                              emptyMessage="Il n'y a pas encore de tâches définies pour ce contrôle."
                            />
                          </Tab.Pane>
                        )
                      },
                      {
                        menuItem: 'Groupes de contrôle',
                        render: () => (
                          <Tab.Pane
                            style={{
                              flex: '1 1 auto',
                              display: 'flex',
                              flexDirection: 'column'
                            }}
                          >
                            <Header
                              style={{
                                flex: '0 0 auto'
                              }}
                              title=''
                              right={
                                <React.Fragment>
                                  <Button
                                    compact={true}
                                    icon='print'
                                    content='Imprimer tous'
                                    color='blue'
                                    onClick={this.onClickPrintAll}
                                  />
                                  <Grant role={Grant.ROLE.MANAGE}>
                                    <Button
                                      compact={true}
                                      icon='plus'
                                      content='Créer'
                                      color='green'
                                      onClick={this.onClickCreateGroup}
                                    />
                                  </Grant>
                                </React.Fragment>
                              }
                            />
                            <Table
                              columns={[
                                // Nom
                                ColumnsProvider.controlGroupName,
                                // Emplacements
                                ColumnsProvider.controlGroupLocations,
                                // Responsable
                                ColumnsProvider.controlGroupManager,
                                // Aides
                                ColumnsProvider.controlGroupHelpers,
                                // Dernier
                                ColumnsProvider.controlGroupLast,
                                // Prochain
                                ColumnsProvider.controlGroupNextWithDetails,
                                // Actions
                                ColumnsProvider.controlGroupActions(
                                  this.onClickPrintGroup,
                                  this.onClickExecuteGroup,
                                  this.onClickUpdateGroup,
                                  this.onClickDeleteGroup
                                )
                              ]}
                              data={this.props.data.groups}
                              error={null}
                              isLoading={false}
                              emptyMessage="Il n'y a pas encore de groupes définis pour ce contrôle."
                            />
                          </Tab.Pane>
                        )
                      }
                    ]}
                  />
                </React.Fragment>
          }
        </Page>
        {
          this.state.isUpdateControl && !_.isNull(this.props.controlId)
            ? <UpdateControlPopup
                id={this.props.controlId}
                onClose={this.onCloseControlUpdate}
              />
            : null
        }
        {
          this.state.isAddProduct && !_.isNull(this.props.controlId)
            ? <AddControlledProductPopup
                controlId={this.props.controlId}
                onClose={this.onCloseAddProduct}
              />
            : null
        }
        {
          !_.isNull(this.state.editProductId)
            ? <EditControlledProductPopup
                controlId={this.props.controlId}
                productId={this.state.editProductId}
                onClose={this.onCloseUpdateProduct}
              />
            : null
        }
        {
          !_.isNull(this.state.deleteProductId)
            ? <Confirm
                header="Suppression d'un matériel"
                body="Êtes-vous sûr de vouloir retirer ce matériel ?"
                confirmText='Retirer'
                confirmColor='red'
                confirmIcon='trash'
                isProceeding={this.props.deleteProductIsFetching}
                callback={this.onConfirmRemoveProduct}
              />
            : null
        }
        {
          this.state.isCreateTask && !_.isNull(this.props.controlId)
            ? <CreateControlTaskPopup
                controlId={this.props.controlId}
                onClose={this.onCloseCreateTask}
              />
            : null
        }
        {
          !_.isNull(this.state.updateTaskId)
            ? <UpdateControlTaskPopup
                id={this.state.updateTaskId}
                onClose={this.onCloseUpdateTask}
              />
            : null
        }
        {
          !_.isNull(this.state.deleteTaskId)
            ? <Confirm
                header="Suppression d'une tâche"
                body="Êtes-vous sûr de vouloir supprimer cette tâche ?"
                confirmText='Supprimer'
                confirmColor='red'
                confirmIcon='trash'
                isProceeding={this.props.deleteTaskIsFetching}
                callback={this.onConfirmDeleteTask}
              />
            : null
        }
        {
          this.state.isCreateGroup && !_.isNull(this.props.controlId)
            ? <CreateControlGroupPopup
                control={_.pick(this.props.data, 'id', 'name')}
                locationsAlreadyused={this.getLocationsAlreadyUsed()}
                onClose={this.onCloseCreateGroup}
              />
            : null
        }
        {
          !_.isNull(this.state.updateGroupId)
            ? <UpdateControlGroupPopup
                id={this.state.updateGroupId}
                locationsAlreadyused={this.getLocationsAlreadyUsed(this.state.updateGroupId)}
                onClose={this.onCloseUpdateGroup}
              />
            : null
        }
        {
          !_.isNull(this.state.deleteGroupId)
            ? <Confirm
                header="Suppression d'un groupe"
                body="Êtes-vous sûr de vouloir supprimer ce groupe ?"
                confirmText='Supprimer'
                confirmColor='red'
                confirmIcon='trash'
                isProceeding={this.props.deleteGroupIsFetching}
                callback={this.onConfirmDeleteGroup}
              />
            : null
        }
        {
          !_.isNull(this.state.executeGroupId)
            ? <ExecuteControlGroupPopup
                id={this.state.executeGroupId}
                onClose={this.onCloseExecuteGroup}
              />
            : null
        }
        {
          !_.isNull(this.state.printGroupId)
            ? <Confirm
                header="Impression d'un groupe"
                body="Vous êtes sur le point d'imprimer la liste de contrôle pour le groupe choisi. Celle-ci sera téléchargée au format PDF. Voulez-vous continuer ?"
                confirmText="Imprimer"
                confirmColor='blue'
                confirmIcon='print'
                isProceeding={this.props.printGroupIsFetching}
                callback={this.onConfirmPrintGroup}
              />
            : null
        }
        {
          this.state.isPrintingAll
            ? <Confirm
                header="Impression de tous les groupes"
                body="Vous êtes sur le point d'imprimer les listes de contrôle pour tous les groupes. Celles-ci seront téléchargées au format PDF. Voulez-vous continuer ?"
                confirmText="Imprimer"
                confirmColor='blue'
                confirmIcon='print'
                isProceeding={this.props.printAllIsFetching}
                callback={this.onConfirmPrintAll}
              />
            : null
        }
      </React.Fragment>
    )
  }
}

ControlViewPage.propTypes = {
  // Properties

  // Redux State
  controlId: PropTypes.number.isRequired,
  data: PropTypes.object,
  isFetching: PropTypes.bool.isRequired,
  error: PropTypes.object,
  deleteProductIsFetching: PropTypes.bool.isRequired,
  deleteProductError: PropTypes.object,
  deleteTaskIsFetching: PropTypes.bool.isRequired,
  deleteTaskError: PropTypes.object,
  deleteGroupIsFetching: PropTypes.bool.isRequired,
  deleteGroupError: PropTypes.object,
  printGroupIsFetching: PropTypes.bool.isRequired,
  printGroupError: PropTypes.object,
  printAllIsFetching: PropTypes.bool.isRequired,
  printAllError: PropTypes.object,

  // Redux Actions
  fetch: PropTypes.func.isRequired,
  deleteProduct: PropTypes.func.isRequired,
  deleteTask: PropTypes.func.isRequired,
  deleteGroup: PropTypes.func.isRequired,
  printGroup: PropTypes.func.isRequired,
  printAll: PropTypes.func.isRequired
}

export default connect(
  (state) => ({
    controlId: state.entities.controls.view,
    data: state.entities.controls.get.full.data,
    isFetching: state.entities.controls.get.full.isFetching,
    error: state.entities.controls.get.full.error,
    deleteProductIsFetching: state.entities.controls.product.delete.isFetching,
    deleteProductError: state.entities.controls.product.delete.error,
    deleteTaskIsFetching: state.entities.controls.task.delete.isFetching,
    deleteTaskError: state.entities.controls.task.delete.error,
    deleteGroupIsFetching: state.entities.controls.group.delete.isFetching,
    deleteGroupError: state.entities.controls.group.delete.error,
    printGroupIsFetching: state.print.controlGroup.isFetching,
    printGroupError: state.print.controlGroup.error,
    printAllIsFetching: state.print.control.isFetching,
    printAllError: state.print.control.error
  }),
  (dispatch) => ({
    fetch: (id) => (dispatch(GetAction({ id }))),
    deleteProduct: (id, product_id) => (dispatch(DeleteProductAction({ id, product_id }))),
    deleteTask: (id) => (dispatch(DeleteTaskAction({ id }))),
    deleteGroup: (id) => (dispatch(DeleteGroupAction({ id }))),
    printGroup: (id) => (dispatch(PrintGroupAction({ id }))),
    printAll: (id) => (dispatch(PrintAllAction({ id })))
  })
)(ControlViewPage)



// WEBPACK FOOTER //
// ./src/containers/pages/ControlViewPage.js